function i(e, t, l, g) {
  for (var n = -1, h = e == null ? 0 : e.length; ++n < h; ) {
    var r = e[n];
    t(g, r, l(r), e);
  }
  return g;
}
var o = i;
export {
  o as default
};
//# sourceMappingURL=_arrayAggregator.js.map
